import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next'; // Import translation hook
import '../style/OrganizationList.css'; // Import the CSS file

const OrganizationList = ({ organizations }) => {
    const [petsByOrg, setPetsByOrg] = useState({}); // Store pets for each organization
    const { t } = useTranslation(); // Translation function

    useEffect(() => {
        const fetchPetsForOrganizations = async () => {
            const storedUser = JSON.parse(localStorage.getItem('user'));
            const token = storedUser?.token;

            if (!token) {
                console.error(t('general.noAuthToken')); // Use translation for error
                return;
            }

            // Filter out organizations with null or undefined organizationId
            const validOrganizations = organizations.filter(org => org.organizationId);

            const promises = validOrganizations.map((org) =>
                axios.get(
                    `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/organizations/${org.organizationId._id}/pets`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
            );

            try {
                const responses = await Promise.all(promises);
                const petsData = responses.reduce((acc, response, index) => {
                    const orgId = validOrganizations[index].organizationId._id;
                    acc[orgId] = response.data.map((pet) => pet.name); // Extract pet names
                    return acc;
                }, {});
                setPetsByOrg(petsData);
            } catch (err) {
                console.error(t('organizationList.fetchErrorLog'), err.response || err.message);
            }
        };

        fetchPetsForOrganizations();
    }, [organizations, t]);

    const getFamilyName = (pets) => {
        if (pets.length === 1) {
            return t('organizationList.familyOfOne', { pet: pets[0] });
        } else if (pets.length === 2) {
            return t('organizationList.familyOfTwo', { pet1: pets[0], pet2: pets[1] });
        } else if (pets.length > 2) {
            return t('organizationList.familyOfMany', {
                pets: pets.slice(0, pets.length - 1).join(', '),
                lastPet: pets[pets.length - 1],
            });
        }
        return t('organizationList.noPets');
    };

    return (
        <div className="organization-list">
            <h2>{t('organizationList.title')} 👨‍👨‍👧‍👧🐥</h2>
            <div className="btn-container">
                {organizations
                    .filter(org => org.organizationId) // Exclude organizations with null organizationId
                    .map((org) => {
                        const orgId = org.organizationId._id; // Access the _id field inside organizationId
                        const pets = petsByOrg[orgId] || []; // Get pets for the organization

                        return (
                            <Link
                                key={orgId}
                                to={`/organizations/${orgId}/pets`}
                                className="btn"
                            >
                                {getFamilyName(pets)}
                            </Link>
                        );
                    })}
            </div>
        </div>
    );
};

export default OrganizationList;